import React from "react"
import PropTypes from "prop-types"

const OpenOrderTitle = props => (
  !!props.openOrder &&
    <div className="open-order-title">
      <button onClick={props.onClose}>X</button>&nbsp;&nbsp;
      {props.openOrder.name}'s Tab
    </div>
)

OpenOrderTitle.propTypes = {
  openOrder: PropTypes.object,
  onClose: PropTypes.func,
}

export default OpenOrderTitle
